<template>
    <div class="container-lineChart_v">
        <v-chart :options="option"  ref="my"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/line'

import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'


export default {
  name: 'lineChart_v',
  props: {  
    title:{
      type: String,
      default: ""
    },
    lineColor:{
      type:String,
      default:"#16CEB9"
    },
    type:{
      type:String,
      default:"consumption_age"
    },
     datalist:{
            type:Array,
            default:()=>{
              return []
            }
        }
  },
   watch:{
        datalist:{
            handler(){  
                          
              this.dataInit();
              this.init()
            },
            deep:false
        }
    },
    
  data () {  
    return {     
        viewdata:[],
        timer:false,
        datelist:[1,2,3,4,5,6,7,8,9,10,11,12],
        viewdate:[],
        option:{}
    
    }
  },
  methods: {
       dataInit(){              
          // debugger
            this.viewdate= this.datelist.slice(0,11); 
            this.viewdata= this.datalist.slice(0,11);        
            this.doit()
        },
        init(){
          var that=this;
          this.option = {      
       grid: {
            top:'10%',
            left: '8%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
             axisLabel: {             
                color:'#FFFFFF',
                rotate:40,
                fontSize:12,
                interval:0
             },
           
            axisTick:{show:false},
            type: 'category',            
            data: that.viewdate,
             splitLine:{ 
                show: true,
                    lineStyle: {
                      color: '#323645',
                      type: 'solid',
                      width:1,
                      opacity:0.5
                    },
              },          
        },
        yAxis: {
         
           axisTick:{show:false},
              splitLine:{ show:false},
              axisLabel: {     
                color:'#FFFFFF'   
              },
              
              type: 'value'     
        },     
        tooltip :{
					formatter:function(params,index){
		var result = ''
            
             
          
            params.forEach(function (item) {
              
              if(that.type=="consumption_age"){
                result=params[0].name+'月' + "</br>"
                      
                  result += "年龄:"+ (item.data=='0.1'?'0':item.data) + "</br>"
              }
              else {
           result=params[0].name + "</br>"
                   result += "购买人数:"+ item.data + "</br>"
              }
            })
						return result
					},
					textStyle:{
						fontSize:18
					},
          trigger: "axis",
        axisPointer: {
          type: "none",
      
        }
        },  
        animation:false,
        series: [{
            data: that.viewdata,
            type: 'line',
            symbol: "circle", 
            symbolSize: 7,             
            itemStyle : { 
                 emphasis: {              
                      borderWidth:5,
                      borderColor: "#fff"               
                 },
                normal : {                  
                  color:this.lineColor, //改变折线点的颜色
                  lineStyle:{ 
                    color:this.lineColor //改变折线颜色
                  },                 
                } 
            },
        }]
         };
this.tips()
      
        },
         rundata(){
             
              this.datelist.push(this.datelist.shift());              
              this.datalist.push(this.datalist.shift());  
              this.tips()
        },
        tips(){
          var that=this;
              that.$nextTick(()=>{
                var o=setTimeout(()=>{
                    that.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex:5                    
                    })
                     that.$refs.my.dispatchAction({
                        type: 'downplay',         
                        seriesIndex: 0,
                        dataIndex:4                    
                    })
                    that.$refs.my.dispatchAction({
                        type: 'highlight',         
                        seriesIndex: 0,
                        dataIndex:5                    
                    })
                    
                    clearTimeout(o)
                 },50)
                  
                   
              })
        },
        //动画
        doit(){    
            let that=this
            if(that.timer){
               clearTimeout(that.timer)
            }
            that.timer=setTimeout(()=>{
                 that.rundata();                
            },3000)
        },
  },
  mounted () {
    this.init()    
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-lineChart_v{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>